type DebugPhase = "crash" | "lesson" | "defuse" | "choose";

const PHASE_BUTTONS: { phase: DebugPhase; label: string }[] = [
  { phase: "crash", label: "Crash" },
  { phase: "lesson", label: "Les" },
  { phase: "defuse", label: "Defuse" },
  { phase: "choose", label: "Kies" },
];

interface DebugPanelProps {
  showLessonPreview: boolean;
  showPositionDebug: boolean;
  activeRoundIndex: number | null;
  activePhase: DebugPhase | null;
  roundCount: number;
  onToggleLesson: () => void;
  onTogglePosition: () => void;
  onJumpRound: (roundIndex: number) => void;
  onJumpPhase: (phase: DebugPhase) => void;
}

export function DebugPanel({
  showLessonPreview,
  showPositionDebug,
  activeRoundIndex,
  activePhase,
  roundCount,
  onToggleLesson,
  onTogglePosition,
  onJumpRound,
  onJumpPhase,
}: DebugPanelProps) {
  return (
    <aside className="act-debug-panel" aria-label="Debug-paneel">
      <p className="act-debug-panel__title">Debug (Ctrl+D)</p>

      <div className="act-debug-panel__group">
        <button
          type="button"
          className={`act-debug-panel__btn${showLessonPreview ? " act-debug-panel__btn--active" : ""}`}
          aria-pressed={showLessonPreview}
          onClick={onToggleLesson}
        >
          ACT-uitleg
        </button>
        <button
          type="button"
          className={`act-debug-panel__btn${showPositionDebug ? " act-debug-panel__btn--active" : ""}`}
          aria-pressed={showPositionDebug}
          onClick={onTogglePosition}
        >
          Posities
        </button>
      </div>

      <div className="act-debug-panel__group">
        <p className="act-debug-panel__label">Ronde</p>
        <div className="act-debug-panel__rounds">
          {Array.from({ length: roundCount }, (_, index) => (
            <button
              key={index}
              type="button"
              className={`act-debug-panel__round-btn${
                activeRoundIndex === index ? " act-debug-panel__round-btn--active" : ""
              }`}
              aria-pressed={activeRoundIndex === index}
              onClick={() => onJumpRound(index)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>

      <div className="act-debug-panel__group">
        <p className="act-debug-panel__label">Fase</p>
        <div className="act-debug-panel__phases">
          {PHASE_BUTTONS.map(({ phase, label }) => (
            <button
              key={phase}
              type="button"
              className={`act-debug-panel__phase-btn${
                activePhase === phase ? " act-debug-panel__phase-btn--active" : ""
              }`}
              aria-pressed={activePhase === phase}
              onClick={() => onJumpPhase(phase)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
}
